import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/images/alpen-pro-logo-new.png" 
                alt="Alpen Pro Suisse" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400 mb-3">
              Professionelle Webseiten für Schweizer Handwerksbetriebe.
            </p>
            <a 
              href="tel:+41762652627"
              className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors font-semibold"
            >
              <Phone className="w-4 h-4" />
              <span>+41 76 265 26 27</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#vorteile" className="text-sm hover:text-cyan-400 transition-colors">Vorteile</a></li>
              <li><a href="#funktioniert" className="text-sm hover:text-cyan-400 transition-colors">Wie es funktioniert</a></li>
              <li><a href="#referenzen" className="text-sm hover:text-cyan-400 transition-colors">Referenzen</a></li>
              <li><a href="#preise" className="text-sm hover:text-cyan-400 transition-colors">Preise</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-white mb-4">Leistungen</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-sm hover:text-cyan-400 transition-colors">Website-Erstellung</a></li>
              <li><a href="#" className="text-sm hover:text-cyan-400 transition-colors">Mobile-Optimierung</a></li>
              <li><a href="#" className="text-sm hover:text-cyan-400 transition-colors">Lokales SEO</a></li>
              <li><a href="#" className="text-sm hover:text-cyan-400 transition-colors">Wartung</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-white mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0 text-cyan-400" />
                <a href="mailto:info@alpenpro.ch" className="text-sm hover:text-cyan-400 transition-colors">
                  info@alpenpro.ch
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 flex-shrink-0 text-cyan-400" />
                <a href="tel:+41762652627" className="text-sm hover:text-cyan-400 transition-colors">
                  +41 76 265 26 27
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-cyan-400" />
                <span className="text-sm">
                  Zürich, Schweiz
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2025 Alpen Pro Suisse. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              <Link to="/datenschutz" className="text-sm hover:text-cyan-400 transition-colors">Datenschutz (DSG)</Link>
              <Link to="/impressum" className="text-sm hover:text-cyan-400 transition-colors">Impressum</Link>
              <a href="#agb" className="text-sm hover:text-cyan-400 transition-colors">AGB</a>
            </div>
          </div>
          <p className="text-center text-sm text-gray-500 mt-4">
            Webseiten für Schweizer Handwerker, die täglich neue Anfragen bringen.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;